import StoreConstructor from '@/store/core/StoreConstructor';
import { action, observable } from 'mobx';
import { RootStores } from '@/store/core/RootStore';
import { nsiApi } from '@/api';
import { IPagedDto } from '@/types/IPagedDto';
import { postDictViolationTypeSearch } from '@/api/endpoints/nsi';
import { ViolationTypeEntity } from '@/entities/ViolationTypeEntity';
import { IDictViolationTypeDto } from '@/types/IDictViolationTypeDto';

export default class ViolationTypesList extends StoreConstructor {
  @observable items: ViolationTypeEntity[] = [];
  @observable loading = false;
  @observable totalItems = 0;

  constructor(stores: RootStores) {
    super(stores);
  }

  @action.bound
  public async fetch(): Promise<void> {
    try {
      this.loading = true;
      const response = await nsiApi.post<IPagedDto<IDictViolationTypeDto>>(
        postDictViolationTypeSearch(),
        { page: { page: 0, size: 10000 } },
      );

      const { data, total } = response.data;
      this.items = data.map((item) => new ViolationTypeEntity(item));
      this.totalItems = total;
    } catch (e) {
      console.error(e);
      this.items = [];
      this.totalItems = 0;
    } finally {
      this.loading = false;
    }
  }
}
